import { fetchDefault } from './fetchDefault';
import { update } from './update';

function init() {
  const locale = fetchDefault();
  update(locale);
}

export { init };
